import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.mjs";import{__require as e}from"../us_zipcode/Result.mjs";var m=r(e());export{m as default};
